import React, { Component } from 'react'
import { MDBContainer, MDBBtn, MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter, MDBTableBody, MDBTable, MDBTableHead,MDBIcon } from 'mdbreact';
import Axios from 'axios'
import { Alert, Form, Input, Button, Select, Icon, message, Tag, Badge, Tooltip, Descriptions   } from 'antd';
import { api, URL } from '../../api';
import Swal from 'sweetalert2/dist/sweetalert2.js'

const date = new Date();
const [month, day, year]  = [String(date.getMonth() + 1).padStart(2, '0'), String(date.getDate()).padStart(2, '0'), date.getFullYear()];
const dates = year+"-"+month+"-"+day ;

export default class ModelcuNotApproveshort extends Component {
    constructor(props) {
              super(props);
      this.state = {
        modal: false,
        Curriculumopen_ID :'',
        Course_ID :'',
        Course_YEAR :'',
        Curriculumopen_TEAM :'',
        Curriculumopen_Full_Name_TH:'',
        Curriculumopen_Full_Name_EN:'',
        Curriculumopen_Detail_TH:'',
        Curriculumopen_Detail_EN:'',
        Curriculumopen_CH:'',
        Curriculumopen_Date_START:'',
        Curriculumopen_Date_END:'',
        Univ_ID:'',
        plan:[],

        comment:'',
        Approve:'3',

        Shortcourse_ID:'',
        Shortcoursemd_Course_ID:'',
        Shortcoursemd_Nameshort_TH:'',
        Shortcoursemd_Nameshort_EN:'',
        Shortcoursemd_Numch:'',
        Shortcoursemd_Numregis:'',
        Shortcoursemd_Timestart:'',
        Shortcoursemd_Timeend:'',
        Shortcoursemd_Univ_id:'',


        
      }

this.handleChangnot = this.handleChangnot.bind(this);
this.updatenotApprove = this.updatenotApprove.bind(this);

}


toggle = () => {
    this.setState({
      modal: !this.state.modal
    });
  }

  handleChangnot(event) {    this.setState({comment: event.target.value});  }

  updatenotApprove() {
    // alert('A name was submitted: ' + this.state.value);
   // console.log(e.target.value)
   if (this.state.comment !='') {
        const id = this.props.Shortcoursemd_ID;
                setTimeout(() => {
                    const datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูล
                    datafrm.append("Shortcoursemd_ID", id);
                    datafrm.append("Approve", this.state.Approve);
                    datafrm.append("comment", this.state.comment);
                    datafrm.append("date", dates);
                    
                    
                    api.post("index/updateNotApproveshort/",datafrm,{
                        headers: {
                            'content-type': 'multipart/form-data'
                        }
                    })

                    .then(res => {
                    //    console.log(res);
                        if (res.status === 200) {
                        //  alert("บันทึกสำเร็จ")
                                Swal.fire({
                                    title: 'ยืนยันการพิจารณาสำเร็จ',
                                    icon: 'success',
                                    // showCancelButton: true,
                                    confirmButtonText: 'ตกลง',
                                    // cancelButtonText: 'No, keep it'
                                    }).then((result) => {
                                    
                                    })
                                }
                        })
                      this.toggle()

                      this.props.showshortcoursemd()
                    //  this.getplan();
                }, 1000);
   } else {

        Swal.fire({
        title: 'กรุณาเพิ่มข้อเสนอแนะ/ความคิดเห็น',
        icon: 'warning',
        // showCancelButton: true,
        confirmButtonText: 'ตกลง',
        // cancelButtonText: 'No, keep it'
        }).then((result) => {
        
        })
       
   }
               

  }

//   getplan() {
//     setTimeout(() => {
//        //ภายใน
//         Axios.get('https://git.kpru.ac.th/FrontEnd_creditbank/index/searchplan/'+this.props.Curriculumopen_ID)
//        .then(res => {
//          console.log(res);
//        //  this.setState({ bankname: res.data, loading: false })
//          this.setState({ plan: res.data})
//        }) 
//      }, 0);
//   }

  componentDidMount() {

    //const { id_send } = this.props.id_send
    //console.log(this.props.Curriculumopen_ID);
    this.setState({ Shortcoursemd_ID:this.props.Shortcoursemd_ID}) 
   
  
    api.get('index/getCurriculumdetalshortmd/'+this.props.Shortcoursemd_ID,
    //  Axios.get(`https://git.kpru.ac.th/FrontEnd_creditbank/index/getteacheruniv/`+localStorage.getItem('Univ_ID'),
      //  Axios.get(`https://mis.kpru.ac.th/api/EmployeeInOrg/000`,
              {headers: {
              // Authorization: 'Bearer ' + localStorage.getItem('myData')
              }
              })
             
              .then(res => {
              // console.log(res.data[0].id)
            
              this.setState({ Shortcourse_ID : res.data[0].Shortcourse_ID });
              this.setState({ Shortcoursemd_Course_ID : res.data[0].Shortcoursemd_Course_ID });
              this.setState({ Shortcoursemd_Nameshort_TH : res.data[0].Shortcoursemd_Nameshort_TH });
              this.setState({ Shortcoursemd_Nameshort_EN : res.data[0].Shortcoursemd_Nameshort_EN });
              this.setState({ Shortcoursemd_Numch : res.data[0].Shortcoursemd_Numch });
              this.setState({ Shortcoursemd_Numregis : res.data[0].Shortcoursemd_Numregis });
              this.setState({ Shortcoursemd_Timestart : res.data[0].Shortcoursemd_Timestart });
              this.setState({ Shortcoursemd_Timeend : res.data[0].Shortcoursemd_Timeend });
              this.setState({ Shortcoursemd_Univ_id : res.data[0].Shortcoursemd_Univ_id });
              
              //    const Curriculumopen = res.data;
               //   this.setState({ Curriculumopen });
       }) 
      // this.getplan();
    }
  

    render() {
        return (
            <>
               
                    <MDBBtn onClick={this.toggle} color="warning" ><MDBIcon icon="times" /> ไม่อนุมัติ</MDBBtn>
                    <MDBModal isOpen={this.state.modal} toggle={this.toggle} size="lg">
                        <MDBModalHeader toggle={this.toggle}>ไม่อนุมัติหลักสูตร</MDBModalHeader>
                        <MDBModalBody>
                        <p className="text-center">  <MDBIcon icon="times-circle" className="red-text pr-3" size="5x" /></p>
                        <h3>หลักสูตร {this.state.Shortcoursemd_Nameshort_TH}</h3>


                        <div className="form-group">
                            <label htmlFor="example2">ข้อเสนอแนะ/คำแนะนำ</label>
                            <input
                            className="form-control"
                            id="exampleFormControlTextarea1"
                            placeholder="ข้อเสนอแนะ/คำแนะนำ"
                            value={this.state.comment} onChange={this.handleChangnot} 
                            rows="5"
                            />
                        </div>

                       <p className="text-center"><MDBBtn color="deep-orange" onClick={this.updatenotApprove}>ยันยันไม่ผ่านพิจารณา</MDBBtn></p> 

                        </MDBModalBody>
                        <MDBModalFooter>
                        <MDBBtn color="secondary" onClick={this.toggle}>ปิด</MDBBtn>
                        {/* <MDBBtn color="primary">Save changes</MDBBtn> */}
                        </MDBModalFooter>
                    </MDBModal>
               
            </>
        )
    }
}
